var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_392)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.962891H513V342.956H0V0.962891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.962891H513V171.959H0V0.962891Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6414 86.4585C83.6414 61.5449 101.152 40.7324 124.533 35.6254C120.87 34.8223 117.131 34.4165 113.381 34.415C84.6373 34.415 61.3379 57.7145 61.3379 86.4575C61.3379 115.201 84.6383 138.501 113.381 138.501C117.211 138.501 120.939 138.075 124.533 137.291C101.152 132.186 83.6414 111.373 83.6414 86.4585ZM150.555 38.1333L154.246 49.4924H166.19L156.526 56.5131L160.218 67.8723L150.555 60.8526L140.891 67.8723L144.583 56.5131L134.919 49.4924H146.864L150.555 38.1333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.582 60.438L125.272 71.7971H137.216L127.552 78.8178L131.244 90.177L121.582 83.1573L111.918 90.177L115.61 78.8178L105.946 71.7971H117.891L121.582 60.438ZM179.529 60.438L183.22 71.7971H195.164L185.5 78.8178L189.192 90.177L179.529 83.1573L169.866 90.177L173.558 78.8178L163.894 71.7971H175.839L179.529 60.438ZM168.376 93.8942L172.067 105.253H184.011L174.349 112.274L178.04 123.633L168.376 116.613L158.714 123.633L162.405 112.274L152.743 105.253H164.686L168.376 93.8942ZM132.734 93.8942L136.424 105.253H148.368L138.705 112.274L142.396 123.633L132.734 116.613L123.071 123.633L126.762 112.274L117.099 105.253H129.042L132.734 93.8942Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_392"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.958984)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSg);
export default __webpack_public_path__ + "static/media/SG.8d42f9e26a9ff9975ab524c182ac8747.svg";
export { ForwardRef as ReactComponent };